import { render, staticRenderFns } from "./RegistrationCard.vue?vue&type=template&id=19caedf9&scoped=true&"
import script from "./RegistrationCard.vue?vue&type=script&lang=js&"
export * from "./RegistrationCard.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCard.vue?vue&type=style&index=0&id=19caedf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19caedf9",
  null
  
)

export default component.exports